/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExistingInitialConsultation } from './existingInitialConsultation';


/**
 * Every error of the public booking API: a code the public app turns into a page or a dialog.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PublicApiError { 
    error: string;
    existingInitialConsultation?: ExistingInitialConsultation;
}
export const PublicApiError_error_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PublicApiError_existingInitialConsultation_Validators: ValidatorFn[] =
    [ ];


